export default __webpack_public_path__ + "static/media/instructions-image-804x305.0429732f.png";